module.exports = __webpack_public_path__ + "static/media/2_GFO_Formoplast_2014-20150626.4adb3d75.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/2_GFO_Formoplast_2014-20150626.pdf
// module id = 182
// module chunks = 0